import React, {forwardRef} from 'react';

import {useMergeRefs} from '@floating-ui/react';

import {useFloatingMenuItem} from '@pb/kit-component-floating';

import {MenuItem} from './menu-item';

import type {MenuItemProps} from './menu-item';
import type {ComponentProps} from 'react';


// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FloatingMenuItemProps extends MenuItemProps {}

/**
 * Renders a single item in FloatingMenu, intended to be used inside FloatingMenu.
 * */
export const FloatingMenuItem = forwardRef<HTMLElement, FloatingMenuItemProps>(({children, ...props}, forwardedRef) => {
    const {
        ref,
        getItemProps,
        highlighted,
        id,
        tabIndex,
    } = useFloatingMenuItem();

    const mergedRef = useMergeRefs([forwardedRef, ref]);

    return (
        <MenuItem
            tabIndex={tabIndex}
            id={id}
            highlighted={highlighted}
            {...getItemProps(props as ComponentProps<'li'>)}
            ref={mergedRef}>
            {children}
        </MenuItem>
    );
});

FloatingMenuItem.displayName = 'FloatingMenuItem';
